import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatErr } from "@/lib/api";
import { tFn } from "@/lib/i18n";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(() => localStorage.getItem("fx_lang") || "en");

  const t = tFn(lang);

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("fx_lang", l);
  };

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      try { localStorage.removeItem("fx_token"); } catch (err) { /* ignore */ }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    try { localStorage.setItem("fx_token", data.token); } catch (e) { /* private mode: session cookie still applies */ }
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    try { localStorage.setItem("fx_token", data.token); } catch (e) { /* private mode: session cookie still applies */ }
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    try { localStorage.removeItem("fx_token"); } catch (e) { /* ignore */ }
    setUser(null);
  };

  return (
    <AppCtx.Provider value={{ user, setUser, loading, lang, changeLang, t, login, register, logout, formatErr }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
